module.exports = (opts) => {
  let fixed = 2
  let min, max

  if (opts && opts.fixed && Number.isInteger(opts.fixed)) fixed = opts.fixed < 12 ? opts.fixed : 12
  fixed = Math.pow(10, fixed)

  const newopts = { fixed: fixed }
  if (opts && opts.min && isNaN(opts.min) === false && opts.max && isNaN(opts.max) === false) {
    min = opts.min * fixed
    max = opts.max * fixed
    newopts['delta'] = max - min + 1
    newopts['offset'] = min
  }

  return newopts
}



// WEBPACK FOOTER //
// ./src/private/scanners/float.js